import React from "react";
import AssociatePerformance from "./AssociatePerformance";
import AssociateFilterContextProvider from "./context/AssociateFilterContext";
import AssociateFilter from "./AssociateFilter";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContext";
import Column from "@amzn/meridian/column";
import {PAGE_HEADERS} from "../util/Constants";
import PageHeader from "../util/PageHeader";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const Associate = () => {
    const {spacingInset_shorthand2} = useDeviceLayout();

    return (
        <Column spacing="medium" spacingInset={spacingInset_shorthand2}>
            <PageHeader {...PAGE_HEADERS.ASSOCIATE}/>
            <AssociateFilterContextProvider>
                <AssociateFilter/>
                <AssociatePerformanceContextProvider>
                    <AssociatePerformance/>
                </AssociatePerformanceContextProvider>
            </AssociateFilterContextProvider>
        </Column>
    )
}
export default Associate


// WEBPACK FOOTER //
// ./src/components/associate/Associate.js